import './index_web.css';
import SwipeableViews from 'react-swipeable-views';
import { Text, TransactionHistoryTabBar, View } from '../../../component';
import DepositHistory from './deposit_history/index';
import WithdrawHistory from './withdraw_history/index';
import GameHistory from './game_history/index';
import PokerHistory from './poker_history/index';
import EarningHistory from './earning_history/index';
import DefaultContainer from '../../default_container';
interface Props {
  activeTab: any;
  onChangeTab: any;
  onChangeIndex: any;
  routes: any;
}
const TransactionHistoryWeb = ({ activeTab, onChangeIndex, onChangeTab, routes }: Props) => {
  return (
    <DefaultContainer>
      <View className="transactionHistory__wrapper__web">
        <View className="transactionHistory__title__web">
          <Text className="transactionHistory__title__txt__web">Transaction History</Text>
        </View>
        <View className="transactionHistory__Tab__container__web">
          <TransactionHistoryTabBar
            routes={routes}
            activeTab={activeTab}
            onChangeTab={onChangeTab}
          />
        </View>

        <SwipeableViews
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center'
          }}
          index={activeTab}
          onChangeIndex={onChangeIndex}>
          <View className={'TH__tab_content'}>{activeTab === 0 && <DepositHistory />}</View>
          <View className={'TH__tab_content'}>{activeTab === 1 && <WithdrawHistory />}</View>
          <View className={'TH__tab_content'}>{activeTab === 2 && <GameHistory />}</View>
          <View className={'TH__tab_content'}>{activeTab === 3 && <PokerHistory />}</View>
          <View className={'TH__tab_content_earning'}>{activeTab === 4 && <EarningHistory />}</View>
        </SwipeableViews>
      </View>
    </DefaultContainer>
  );
};
export default TransactionHistoryWeb;
